import { Container, IDestroyOptions, TextStyle, Text } from "pixi.js";
import { IFortuneWheelModel } from "../../../model/IFortuneWheelModel";
import { TextWithTime } from "../../../../../common/components/TextWithTime";
import { GameFont } from "../../../../../common/GameFont";
import { nameof } from "bindable-data";
type Timeline = gsap.core.Timeline;

export class HourlyBonusPanelInfoText extends Container {
    private static readonly COME_BACK_TEXT = "COME BACK IN ";
    private static readonly COME_BACK_COMPLETE_TEXT = "COME BACK IN 00:00";
    private static readonly MIN_TEXT = "MIN";
    private static readonly COLLECT_TEXT = "COLLECT YOUR PRIZE";
    private static readonly TO_COLLECT_TEXT = "TO COLLECT YOUR PRIZE";

    private readonly fortuneWheelModel: IFortuneWheelModel;
    private timeText: TextWithTime;
    private minText: Text;
    private collectText: Text;

    public constructor(
        fortuneWheelModel: IFortuneWheelModel
    ) {
        super();
        this.fortuneWheelModel = fortuneWheelModel;
        this.build();
        this.updateTime();
        this.updateTexts();
        this.fortuneWheelModel.propertyChanged.add(this.onFortuneWheelModelPropertyChanged, this);
    }

    private async onFortuneWheelModelPropertyChanged(model: IFortuneWheelModel, key: string): Promise<void> {
        switch (key) {
            case nameof(model, "spinAvailableIn"):
                this.updateTime();
                break;
        }
    }

    private build(): void {
        this.timeText = new TextWithTime(this.fortuneWheelModel.spinAvailableIn.value, HourlyBonusPanelInfoText.COME_BACK_TEXT, HourlyBonusPanelInfoText.COME_BACK_COMPLETE_TEXT, new InfoTextStyle());
        this.timeText.position.y = -30;
        this.timeText.anchor.set(0.5);
        this.addChild(this.timeText);

        this.minText = new Text(HourlyBonusPanelInfoText.MIN_TEXT, new InfoTextStyle());
        this.minText.anchor.set(0.5);
        this.minText.position.y = -30;
        this.minText.position.x = this.timeText.position.x + this.timeText.width * 0.5 + 55;
        this.timeText.position.x = - this.minText.width * 0.5 - 5;
        this.addChild(this.minText);

        this.collectText = new Text(HourlyBonusPanelInfoText.COLLECT_TEXT, new InfoTextStyle());
        this.collectText.anchor.set(0.5);
        this.collectText.position.y = 30;
        this.addChild(this.collectText);
    }

    private updateTime(): void {
        const spinAvailableIn = this.fortuneWheelModel.spinAvailableIn.value;
        this.timeText.updateTime(spinAvailableIn);
    }

    public async updateTexts(): Promise<void> {
        const spinAvailableIn = this.fortuneWheelModel.spinAvailableIn.value;
        this.timeText.visible = spinAvailableIn != 0;
        this.minText.visible = spinAvailableIn != 0;
        this.collectText.text = spinAvailableIn > 0 ? HourlyBonusPanelInfoText.TO_COLLECT_TEXT : HourlyBonusPanelInfoText.COLLECT_TEXT;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.fortuneWheelModel.propertyChanged.remove(this.onFortuneWheelModelPropertyChanged, this);
        super.destroy(options);
    }
}

class InfoTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            leading: 5,
            dropShadow: true,
            dropShadowAlpha: 0.3,
            dropShadowAngle: 0.9,
            dropShadowBlur: 5
        }));
    }
}
